import 'twin.macro';
import React from 'react';
import ButtonRadio from '@teetsh/app/src/components/Form/ButtonsRadio/formWrapper';
import { Field, Form } from 'react-final-form';
import { Teacher } from '@teetsh/app/src/containers/Livrets/types/livret';
import Input from '@teetsh/app/src/components/Form/InputGroup/formWrapper';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';

interface Props {
  onUpdate: (v: Teacher) => Promise<any>;
  onClose: () => void;
}

export function AdditionalTeachersForm(props: Props) {
  const { t } = useTranslation(['carnet', 'common']);
  const { required } = useTranslatedValidation();
  return (
    <Form<Teacher>
      initialValues={{
        gender: 'F',
        givenName: '',
        familyName: '',
      }}
      keepDirtyOnReinitialize
      onSubmit={v => props.onUpdate(v).then(() => props.onClose())}
    >
      {({ handleSubmit, invalid, submitting }) => (
        <form onSubmit={handleSubmit}>
          <div tw="mb-1 mt-4">
            <Field
              name="gender"
              label={t('carnet:civilite')}
              options={[
                {
                  label: t('carnet:monsieur'),
                  value: 'H',
                },
                {
                  label: t('carnet:madame'),
                  value: 'F',
                },
              ]}
              component={ButtonRadio}
            />
          </div>
          <div tw="flex items-baseline gap-x-1">
            <div tw="flex-grow">
              <Field
                name="familyName"
                label={t('carnet:lastName')}
                autoFocus
                validate={required}
                component={Input}
              />
            </div>
            <div tw="flex-grow">
              <Field
                name="givenName"
                validate={required}
                label={t('carnet:firstName')}
                component={Input}
              />
            </div>
          </div>
          <div tw="flex items-center justify-end gap-x-1 mt-2">
            <Button minimal onClick={() => props.onClose()}>
              {t('common:buttons.cancel')}
            </Button>
            <Button
              type="submit"
              loading={submitting}
              intent="primary"
              small
              disabled={invalid}
            >
              {t('common:buttons.validate')}
            </Button>
          </div>
        </form>
      )}
    </Form>
  );
}
